
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-courses",
      function () {
        return require("private-next-pages/all-courses/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-courses"])
      });
    }
  